import { types } from "mobx-state-tree";

export const QuestionAnswer = types.model("QuestionAnswer", {
  answer: types.string,
  question: types.string,
  related_to: types.string 
});